<template>
  <el-drawer
  :title="title"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :append-to-body="true"
  :size="width"
  v-loading="loading"
  @open="open">
  <el-row class="text-right m-10 mr-40" v-if="visible">
    <span class="bg-warning-lighter p-10">{{ $t('credit_notes.outstanding') }} {{$n(balanceToPay, 'currency',invoice.currency.code )}}</span>
  </el-row>
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-table
      :data="creditNotesModel"
      stripe
      v-if="visible"
      style="width: 100%">
      <el-table-column
        prop="cr_number"
        :label="$t('credit_notes.creditNoteNumber')">
      </el-table-column>
      <el-table-column
        :label="$t('credit_notes.date')">
        <template slot-scope="scope">
          {{_moment(scope.row.date)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('credit_notes.creditAmount')">
        <template slot-scope="scope">
          {{$n(scope.row.total, 'currency',scope.row.currency.code)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('credit_notes.creditAvailable')">
        <template slot-scope="scope">
          {{$n(creditBalance(scope.row), 'currency',scope.row.currency.code)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('credit_notes.amount')">
        <template slot-scope="scope">
          <el-input-number :value="scope.row.amount" size="small" :precision="2" :min="0" :max="ncMax[scope.$index]" @change="v=>{setAmount(scope.$index, v)}"></el-input-number>
        </template>
      </el-table-column>
    </el-table>
    <table style="width:100%;padding-right:40px;" class="text-right" v-if="visible">
      <tr>
        <td><span>{{ $t('credit_notes.amountToBeCredited') }}</span></td>
        <td style="width:150px"><span>{{$n(creditedAmount, 'currency',invoice.currency.code )}}</span></td>
      </tr>
      <tr style="margin:20px;">
        <td><span>{{ $t('credit_notes.amountToBePaid') }}</span></td>
        <td><span>{{$n(balanceLeft, 'currency',invoice.currency.code )}}</span></td>
      </tr>
    </table>
  </div>
  <div class="dialog-footer card-shadow--large">
    <el-button @click="handleClose">{{ $t('common.Cancel') }}</el-button>
    <el-button type="primary" @click="save">{{ $t('common.apply') }}</el-button>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment-timezone'
import creditNoteApi from '@/services/API/creditNote'

export default {
  name: 'credit-note-application-drawer',
	props: {
    editCreditNotes : { type : Array},
    invoice : {type : Object},
    balanceToPay : {type : Number},
    creditNotes : {type : Array},
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      loading : false,
      cpt : 0,
      creditNotesModel : [],
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {

  },
  watch : {
    cpt: function (val) {
      this.fullName = val + ' ' + this.lastName
    }
  },
	methods: {
    max(creditNote){
      return this.creditBalance(creditNote) < this.balanceToPay ? this.creditBalance(creditNote) : this.balanceToPay;
    },
    save(){
      if(this.balanceToPay<0){
        this.$message({message : 'Le montant a payé de la facture est est négatif. Veuillez réajuster les montants à appliquer.', type : 'error'})
      }if(this.creditedAmount==0){
        this.$message({message : "Veuille spécifier des montants pour crédité la facture", type : 'error'})
      }else{
        let creditNotes = [];
        _.forEach(this.creditNotesModel, cn=>{
          if(cn.amount>0)creditNotes.push(_.cloneDeep(cn));
        })
        this.$emit('apply',creditNotes);
        this.handleClose();
      }

    },
    _moment(datetime, format='DD/MM/YYYY'){
      return moment(datetime).format(format);
    },
    setAmount(index, value){
      let amountValue = value;
      //On valide si la valeur est plus grande que la valeur de la note de crédit
      let max = this.max(this.creditNotesModel[index]);
      if(amountValue > max ){amountValue = max;}
      this.creditNotesModel[index].amount=amountValue;
      this.ctp++;
    },
    convertCreditNotes(){
      this.creditNotesModel = [];
      let creditNoteToUse = (this.editCreditNotes!=null && this.editCreditNotes.length>0) ? this.editCreditNotes : this.creditNotes;
      // console.log("creditNoteToUse : ", creditNoteToUse);
      _.forEach(creditNoteToUse, c=>{
        let creditNote = {
          id : c.id,
          currency : {
            id:c.currency.id,
            code : c.currency.code
          },
          invoices : c.invoices,
          cr_number : c.cr_number,
          date : c.date,
          total : c.total,
          status : c.status,
          amount : c.amount||0.00
        }
        this.creditNotesModel.push(creditNote);
      })
    },
    open(){
      if(this.creditNotes ==null && this.editCreditNotes == null){
        this.loading=true;
        creditNoteApi.fetchCreditNotes({paging:'no', statusCode:['INIT','PARTIALLY_PAID'], customerId:this.invoice.customer.id})
          .then(creditNotes=>{
            this.creditNotesModel = [];
            _.forEach(creditNotes, cn=>{
              cn.amount = 0.00;
              let line =  {
                cr_number : cn.cr_number,
                amount : 0.00,
                date : cn.date
              }
              this.creditNotesModel.push(cn);
            })
            this.loading=false;
          })
      }else{
        this.convertCreditNotes()
      }
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    // ...mapActions('inventoryProducts', ['fetchSelectedProduct','fetchInventory'])
	},
	computed: {
    ncMax(){
        this.cpt;
        let maxs = [];
        _.forEach(this.creditNotesModel, (cn, index)=>{
          //Le maximum est soit le nombre
          let max = this.creditLeft[index] < (this.balanceLeft+cn.amount)? this.creditLeft[index] : (this.balanceLeft+cn.amount);
          maxs.push(max);
        })
        return maxs;


    },
    creditLeft(){
      let creditLeft = [];
      _.forEach(this.creditNotesModel, cn=>{
        creditLeft.push(this.creditBalance(cn));
      })
      return creditLeft;
    },
    creditedAmount(){
      let creditedAmount = 0.00;
      _.forEach(this.creditNotesModel, c=>{
        if(c.amount!=null){
          creditedAmount +=c.amount;
        }
      })
      return creditedAmount;
    },
    balance(){
      return this.balanceToPay - this.creditedAmount;
    },
    balanceLeft(){
      return this.balance < 0 ? 0 : this.balance;
    },
    title(){
      if(this.invoice.inv_number==null){
        return this.$i18n.t('credit_notes.creditNoteApplicationTitle');
      }else{
        return this.$i18n.t('credit_notes.creditNoteApplicationForTitle');
      }

    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "70%";
      }else{
        return "100%"
      }
    },
    ...mapGetters('creditNotes',['creditBalance'])
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:60px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
